<div [class]="showSpinner ? 'visible spinner center' : 'hidden spinner center'" [innerHTML]="template"></div>